import React from 'react';

const FoundationsLogoSquare = () => {
  return (
    React.createElement('svg', {
      width: "21",
      height: "20",
      viewBox: "0 0 21 20"   ,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",}
    
      , React.createElement('g', { 'clip-path': "url(#clip0_2735_11238)",}
        , React.createElement('rect', {
          x: "10.417",
          y: "8.59671",
          width: "5.66667",
          height: "5.67736",
          fill: "url(#pattern0)",}
        )
        , React.createElement('path', {
          d: "M3.3335 1.5V18.5321C6.46315 18.5321 9.00016 15.9903 9.00016 12.8547V8.47517C8.77851 8.55353 8.54034 8.5967 8.29183 8.5967C7.11836 8.5967 6.16683 7.64337 6.16683 6.46769C6.16683 5.292 7.11836 4.33868 8.29183 4.33868C9.4653 4.33868 10.4168 5.292 10.4168 6.46769C10.4168 6.71666 10.3737 6.95529 10.2955 7.17736H17.5002V1.5H3.3335Z"                               ,
          fill: "#F73859",}
        )
        , React.createElement('path', {
          d: "M10.417 14.5106V8.59671H16.3198C16.3198 11.863 13.6771 14.5106 10.417 14.5106Z"      ,
          fill: "#F73859",}
        )
      )
      , React.createElement('defs', null
        , React.createElement('pattern', {
          id: "pattern0",
          patternContentUnits: "objectBoundingBox",
          width: "1",
          height: "1",}
        
          , React.createElement('use', { xlinkHref: "#image0_2735_11238", transform: "scale(0.00520833)",} )
        )
        , React.createElement('clipPath', { id: "clip0_2735_11238",}
          , React.createElement('rect', {
            width: "20",
            height: "20",
            fill: "white",
            transform: "translate(0.333496)",}
          )
        )
        , React.createElement('image', {
          id: "image0_2735_11238",
          width: "192",
          height: "192",
          xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMAAAADACAYAAABS3GwHAAAACXBIWXMAAAsSAAALEgHS3X78AAAC/ElEQVR4nO3ZQU4bQRRF0U+UCftfLMMgBi05EQEMbru67zlb8LtVZfvp5eXlz0DULx88ZQIgTQCkCYA0AZAmANIEQJoASBMAaQIgTQCkCYA0AZAmANIEQJoASBMAaQIgTQCkCYA0AZAmANIEQJoASBMAaQIgTQCkCYA0AZAmANIEQJoASBMAaQIgTQCkCYA0AZAmANIEQJoASBMAaQIgTQCkCYA0AZAmANIEQJoASBMAaQIgTQCkCYA0AZAmANIEQJoASBMAaQIgTQCkCYA0AZAmANIEQJoASBMAaQIgTQCkCYA0AZAmANIEQJoASBMAaQIgTQCkCYA0AZAmANIEQJoASBMAaQIgTQCkCYA0AZAmANIEQJoASBMAaQIgTQCkCYA0AZAmANIEQJoASBMAaQIgTQCkCYA0AZAmANIEQJoASBMAaQIg6/n5+UkApAmANAGQJgDSBECaAEgTAGkCIE0ApAmApLd/gUcA1AmANAGQsz1/RgDUCYA0AZBy+fwZAVAnANIEQJoAyPj3/T8CoE4ApAmAhPeePyMA6gRAmgA4vf89f0YA1AmANAFwah89f0YA1AmA0/rs9B8BcFZfGf8IgDoBcDpfPf1HANQJgFO55vQfAVAnAE7j2tN/BECdADiF75z+IwDqBMDhfff0HwFwdD8Z/wiAOgFwWD89/UcAHNUtxj8C4IhuNf4RAHUC4FBuefqPADiSW49/BMBR7DH+EQBHsNf4RwCsbs/xjwCoEwDL2vv0HwGwqnuMfwTAiu41/hEAq7nn+EcArOTe4x8BsIpHjH8EwAoeNf43vy2AR3nk8DduAB5ihfGPAHiEVcY/AuDeVhr/CIB7Wm3840sw97Di8DduAHa18vhHAOxp9fGPJxB7OMLwN24AbupI4x83ALdytOFvBMCPHHX4GwHwLUcf/kYAXOUsw98IgC852/A3fgXiU2cd/7gB+MiZh78RAH8pjP6SAMiN/pIAosqjvySACIN/nwBOzOg/J4CTMfrrCOAgDHsHM/MKpq0LiF3YKhcAAAAASUVORK5CYII=",}
        )
      )
    )
  );
};

export default FoundationsLogoSquare;
